{
  "name": "portal-client",
  "type": "module",
  "milestone": "1.12",
  "version": "1.11.111",
  "description": "GFAL Web3 Client",
  "private": true,
  "license": "AGPL-3.0 license",
  "authors": "Danny Vogel, Pau Val, Joan Cifo, Carlos Falguera, Blai Calero, David Llort, Jordi Biosca, Nacho Galceran, Christian Gascons, Miquel Miró",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/gamesforaliving/portal-client"
  },
  "bugs": {
    "url": "https://github.com/gamesforaliving/portal-client/issues"
  },
  "homepage": "https://github.com/gamesforaliving/portal-client#readme",
  "keywords": [
    "GFAL Client",
    "GFAL Portal",
    "GFAL Marketplace",
    "GFAL DAO",
    "GFAL Social"
  ],
  "main": "index.ts",
  "_moduleAliases": {
    "@": "./src",
    "~": "./src"
  },
  "scripts": {
    "build": "nuxt build",
    "changelog:add": "node scripts/changelog-add.cjs",
    "changelog:prepare": "node scripts/changelog-prepare.cjs",
    "commit:smart": "node scripts/commit-and-push-with-changelog.cjs",
    "dev": "nuxt dev",
    "generate": "nuxt generate",
    "preview": "nuxt preview",
    "postinstall": "node -e \"const fs=require('fs'); if (fs.existsSync('./scripts/setup-hooks.cjs')) require('./scripts/setup-hooks.cjs')\" && nuxt prepare",
    "worktree:create": "node scripts/create-worktree.mjs"
  },
  "dependencies": {
    "@chenfengyuan/vue-countdown": "^2.1.3",
    "@iconify-json/mdi": "^1.2.3",
    "@iconify-json/svg-spinners": "^1.2.4",
    "@neoconfetti/vue": "^2.2.1",
    "@nuxt/fonts": "0.11.4",
    "@nuxt/icon": "1.14.0",
    "@nuxt/scripts": "^0.11.13",
    "@nuxt/test-utils": "^3.19.2",
    "@nuxtjs/i18n": "^10.1.0",
    "@pinia/nuxt": "0.11.1",
    "@ramp-network/ramp-instant-sdk": "^6.2.0",
    "@tailwindcss/vite": "^4.1.13",
    "@types/elliptic": "^6.4.18",
    "@vue/test-utils": "^2.4.6",
    "@vueform/slider": "^2.1.10",
    "@vueuse/nuxt": "13.4.0",
    "dotenv": "^17.2.3",
    "elliptic": "^6.6.1",
    "ethers": "^6.15.0",
    "h3-compression": "^0.3.2",
    "happy-dom": "^18.0.1",
    "nuxt": "^4.1.2",
    "nuxt-gtag": "^3.0.3",
    "nuxt-headlessui": "^1.2.1",
    "nuxt-svgo": "4.2.2",
    "pdf-lib": "^1.17.1",
    "pinia": "3.0.3",
    "qrcode": "^1.5.4",
    "vitest": "^3.2.4",
    "vue": "^3.5.22",
    "vue-qrcode-reader": "^5.7.3",
    "vue-toastification": "^2.0.0-rc.5",
    "vue-use-paginator": "^0.4.2"
  },
  "devDependencies": {
    "tailwindcss": "^4.1.13"
  },
  "overrides": {
    "vite": "npm:rolldown-vite@latest"
  },
  "lastCommitVersionUpdate": "2026-09-09T09:57:22.817Z"
}
